import { useNavigate } from "react-router-dom";
import { SMART_OFFICE_ERROR_CODE } from "../../consts/code";

export const useSmartOffice = () => {
  const navigate = useNavigate();

  const failedRedirect = (code?:number) => {
    if (code === SMART_OFFICE_ERROR_CODE.NOT_VERIFIED_COMPANY) {
        navigate("/myinfo", { replace: true });
    } else if (code === SMART_OFFICE_ERROR_CODE.INVALIDE_SMARTOFFICE_BUILDING) {
        navigate("/myinfo/change/building" , { replace: true });
    } else {
        navigate("/view", { replace: true });
      // navigate(-1);
    }
  }
  
  return {failedRedirect}
}
